import * as yup from 'yup'
import { CompanyDto } from './companyDto'

export class DamageDto {
  vehicleGuid?: string = undefined
  damageId?: string = undefined
  vin?: string = undefined
  year?: number = undefined
  make?: string = undefined
  model?: string = undefined
  importerStockNumber?: string = undefined
  exporterCompany?: CompanyDto = undefined
  buyerCompany?: CompanyDto = undefined
  initialDamageDate?: string = undefined
  updatedDate?: string = undefined
  updatedBy?: string = undefined
  // damageStatus?: string = undefined
  damageDescription?: string = undefined
  importBranch?: string = undefined
  createdDate?: string = undefined
  createdBy?: string = undefined
}

export const damageValidationSchema = yup.object({
  vehicleGuid: yup.string().nullable(),
  vin: yup.string().min(17, 'VIN must be 17 characters.').max(17, 'VIN must be 17 characters.').required('VIN is required.'),
  year: yup
    .number()
    .min(1954, 'Year cannot be less than 1954.')
    .max(2100, 'Year cannot be more than 2100.')
    .required('Year is required.'),
  make: yup.string().max(200, 'Make cannot be more than 200 characters.').required('Make is required.'),
  model: yup.string().max(200, 'Model cannot be more than 200 characters.').required('Model is required.'),
  importerStockNumber: yup.string().max(50, 'Importer Stock # cannot be more than 50 characters.').nullable(),
  exporterCompany: yup.object().nullable(),
  buyerCompany: yup.object().nullable(),
  initialDamageDate: yup.string().nullable(),
  updatedDate: yup.string().nullable()
  // damageStatus: yup.string().nullable()
})
